module.exports = __webpack_public_path__ + "img/helpImage.42811898.svg";